import { HyperLinkType } from '../components/PdfViewer/index.types';

/* mailto: · tel: · sms:는 새 탭이 아니라 OS 핸들러로 넘겨야 한다.
 window.open을 쓰면 데스크톱에 빈 탭이 남고, iOS Safari에서는 팝업 차단에 걸린다 */
const DEVICE_SCHEMES = ['mailto:', 'tel:', 'sms:'];

/* 백필이 없어 기존 파일은 type: 'url' + url: 'mailto:...' 형태로 남아 있다.
 타입과 url 스킴을 함께 보고 레거시 데이터까지 같이 처리한다 */
export const isDeviceLink = (type: HyperLinkType['type'], url: string) =>
  type === 'email' ||
  type === 'phone' ||
  type === 'sms' ||
  DEVICE_SCHEMES.some((scheme) => url.toLowerCase().startsWith(scheme));
